import { useState } from 'react';
import { useMobile } from './MobileContext';
import { ChevronDown, ExternalLink, Building, FolderOpen } from 'lucide-react';

const LinkRow = ({ l, isRTL, indent }) => (
  <a href={l.url} target="_blank" rel="noreferrer" className={`flex items-center gap-3 py-3 active:bg-slate-50 ${indent ? 'ps-8 pe-4' : 'px-4'}`} data-testid={`m-link-${l.id}`}>
    <div className="flex-1 min-w-0"><p className="text-sm font-semibold text-slate-800">{isRTL ? l.title_ar : (l.title_en || l.title_ar)}</p>{(l.desc_ar || l.desc_en) && <p className="text-[11px] text-slate-500">{isRTL ? l.desc_ar : (l.desc_en || l.desc_ar)}</p>}</div>
    <ExternalLink className="w-4 h-4 text-[#D4AF37] shrink-0" />
  </a>
);

const CategoryBlock = ({ gKey, c, isRTL }) => {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid={`m-category-${gKey}-${c.ar}`}>
      <button onClick={() => setOpen(o => !o)} className="w-full flex items-center gap-3 px-4 py-3 bg-amber-50/70 text-start" data-testid={`m-category-toggle-${gKey}-${c.ar}`}>
        <FolderOpen className="w-4 h-4 text-[#b8952b] shrink-0" />
        <p className="flex-1 text-sm font-bold text-slate-800">{isRTL ? c.ar : (c.en || c.ar)}</p>
        <span className="text-[10px] text-slate-400">{c.links.length}</span>
        <ChevronDown className={`w-4 h-4 text-slate-500 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && <div className="divide-y divide-slate-100 border-t border-amber-100">{c.links.map(l => <LinkRow key={l.id} l={l} isRTL={isRTL} indent />)}</div>}
    </div>
  );
};

export default function MInquiries() {
  const { content, isRTL, t, loading } = useMobile();
  const [open, setOpen] = useState(null);
  const groups = [];
  content.links.forEach(l => {
    const key = l.authority_ar || t('أخرى', 'Other');
    let g = groups.find(x => x.key === key);
    if (!g) { g = { key, ar: l.authority_ar, en: l.authority_en, desc_ar: l.authority_desc_ar, desc_en: l.authority_desc_en, links: [], cats: [] }; groups.push(g); }
    if (l.category_ar) {
      let c = g.cats.find(x => x.ar === l.category_ar);
      if (!c) { c = { ar: l.category_ar, en: l.category_en || '', links: [] }; g.cats.push(c); }
      c.links.push(l);
    } else g.links.push(l);
  });
  return (
    <div className="p-3 space-y-2" data-testid="m-inquiries">
      <div className="px-1 pb-1"><h1 className="text-lg font-bold text-slate-900">{t('الاستعلامات', 'Inquiries')}</h1><p className="text-xs text-slate-500">{t('اختر الجهة ثم القسم أو الخدمة للانتقال إلى الموقع الرسمي', 'Pick an authority, then a category or service to open the official site')}</p></div>
      {loading && <p className="text-center text-xs text-slate-400 py-8">{t('جاري التحميل...', 'Loading...')}</p>}
      {groups.map(g => {
        const isOpen = open === g.key;
        const total = g.links.length + g.cats.reduce((a, c) => a + c.links.length, 0);
        return (
          <div key={g.key} className="rounded-2xl overflow-hidden border border-slate-200 bg-white" data-testid={`m-authority-${g.key}`}>
            <button onClick={() => setOpen(isOpen ? null : g.key)} className="w-full flex items-center gap-3 p-3.5 bg-[#0F172A] text-white text-start" data-testid={`m-authority-toggle-${g.key}`}>
              <div className="w-9 h-9 rounded-xl bg-[#1e293b] flex items-center justify-center shrink-0"><Building className="w-4 h-4 text-[#D4AF37]" /></div>
              <div className="flex-1 min-w-0"><p className="text-sm font-bold">{isRTL ? g.ar : (g.en || g.ar)}</p>{(g.desc_ar || g.desc_en) && <p className="text-[11px] text-white/60 truncate">{isRTL ? g.desc_ar : (g.desc_en || g.desc_ar)}</p>}</div>
              <span className="text-[10px] text-white/50">{total}</span>
              <ChevronDown className={`w-4 h-4 text-white/70 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>
            {isOpen && <div className="divide-y divide-slate-100">
              {g.links.map(l => <LinkRow key={l.id} l={l} isRTL={isRTL} />)}
              {g.cats.map(c => <CategoryBlock key={c.ar} gKey={g.key} c={c} isRTL={isRTL} />)}
            </div>}
          </div>
        );
      })}
    </div>
  );
}
